import React from "react";
import "./Filter.css";

const Filter = ({ children, className = "", ...props }) => {
  return (
    <select className={`filter ${className}`} {...props}>
      {children}
    </select>
  );
};

export default Filter;
